//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationFlowModal",
  components: {
    GenericModal,
    SimpleButton
  },
  data() {
    return {
      flow: ""
    };
  },
  mounted() {
    this.$show = this.show;
  },
  methods: {
    show(flow) {
      this.flow = flow;
      this.$showModal();
    },
    handleConfirmClick() {
      this.$hideModal();
      this.$emit("submit", this.flow);
    }
  }
});